export default "__VITE_ASSET__DA2JcZ$F__"